// extracted by mini-css-extract-plugin
module.exports = {"main":"AppLayout_main__3PbME"};